import { useLegalPdfUrl } from '@common/hooks/use-legal-pdf-url';
import { useLegalModalStore } from '@common/stores/legal-modal-store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@konova/ui/button';
import { Link } from '@konova/ui/link';
import { List, ListItem } from '@konova/ui/list';
import { Modal } from '@konova/ui/modal';
import { Typography } from '@konova/ui/typography';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type PrivacyModalProps = {
  pdfUrl?: string | null;
};
export const PrivacyModal: FC<PrivacyModalProps> = ({ pdfUrl }) => {
  const { t } = useTranslation();
  const show = useLegalModalStore(state => state.showPrivacyModal);
  const setShow = useLegalModalStore(state => state.setShowPrivacyModal);

  const legalPdf = useLegalPdfUrl();

  const onClose = () => setShow(false);

  return (
    <Modal
      size="lg"
      open={show}
      onClose={onClose}
      data-testid="privacy-modal"
      label={t('components.privacy-modal.title')}
      title={(
        <Typography as="h3" variant="h3">
          {t('components.privacy-modal.title')}
        </Typography>
      )}
      footer={(
        <Button data-testid="close" variant="filled" onClick={onClose}>
          {t('common.close')}
        </Button>
      )}
    >
      <Typography as="h4" variant="h4" bold>
        {t('components.privacy-modal.subtitle')}
      </Typography>

      <List variant="decorated" as="ul">
        <ListItem as="li">
          <Typography variant="paragraph">
            {t('components.privacy-modal.bullet1')}
          </Typography>
        </ListItem>
        <ListItem as="li">
          <Typography variant="paragraph">
            {t('components.privacy-modal.bullet2')}
          </Typography>
        </ListItem>
        <ListItem as="li">
          <Typography variant="paragraph">
            {t('components.privacy-modal.bullet3')}
          </Typography>
        </ListItem>
        <ListItem as="li">
          <Typography variant="paragraph">
            {t('components.privacy-modal.bullet4')}
          </Typography>
        </ListItem>
      </List>

      <Typography as="h4" variant="h4">
        {t<string>('components.privacy-modal.detailed-regulations')}
      </Typography>

      <Typography as="p">
        <Link
          target="_blank"
          href={pdfUrl ?? legalPdf}
          rel="noopener noreferrer"
          color="primary"
        >
          <FontAwesomeIcon icon={['fal', 'external-link-alt']}/>
          &nbsp;
          {' '}
          {t('common.privacy')}
        </Link>
      </Typography>
    </Modal>
  );
};
